// Get CSS variable value or fallback
const getCssVar = (varName, fallback) => {
  if (typeof window !== 'undefined') {
    const value = getComputedStyle(document.documentElement).getPropertyValue(varName).trim();
    return value || fallback;
  }
  return fallback;
};

// Primary color from CSS variable (set by theme)
const primaryColor = getCssVar('--color-primary', '#FFDC00');
const primaryHover = getCssVar('--color-primary-hover', '#F7C500');

export const Colors = {
  green: '#96C31E',
  yellow: primaryColor,
  yellowHover: primaryHover,
  primary: primaryColor,
  primaryHover: primaryHover,
  grey: '#F4F4F4',
  greyAction: '#dddddd',
  greyDark: '#757575',
  textGrey: '#757575',
  textBlack: '#1A1A1A',
  overlay: '#1A1A1A50',
  white: '#FFF',
};

export default Colors;
